import { createTheme } from '@mui/material/styles';
import './tokens';

const defaultTheme = createTheme({
  cssVariables: true,
  palette: {
    navigation: {
      background:        '#2a2e42',
      subPanelBg:        '#2a2e42',
      divider:           'rgba(255, 255, 255, 0.2)',
      tabSelectedBg:     '#0857c3',
      tabSelectedBorder: '#ffffff',
      // Selected rows keep white subPanelText: 6.64:1.
      itemSelectedBg:    '#0857c3',
      // was #3a8af7 — 3.93:1 on subPanelBg. Now 5.02:1.
      link:              '#5FA0F8',
      badge:             '#f73a5b',
      text:              '#ffffff',
      textMuted:         'rgba(255, 255, 255, 0.7)',
      subPanelText:      '#ffffff',
      subPanelTextMuted: 'rgba(255, 255, 255, 0.7)',
      subPanelAvatarBg:  'rgba(255, 255, 255, 0.2)',
    },
    surface: {
      appBackground:    '#F9FAFB',
      chatPanelBg:      '#FFFFFF',
      chatHeaderBg:     '#FFFFFF',
      inputBg:          '#FFFFFF',
      inputBorder:      '#D1D5DB',
      inputBorderFocus: '#1565C0',
      inputText:        '#555759',
      divider:          'rgba(0, 0, 0, 0.08)',
      primaryText:      '#1A1F2E',
      // was #7A8194 — 3.89:1 on white, below the 4.5:1 floor. Now 5.72:1.
      secondaryText:    '#5F6773',
      emptyStateIcon:   '#8E97A3',
      toastBg:          '#1A1F2E',
      toastText:        '#ffffff',
    },
    chat: {
      userBubbleBg:          '#225CAA',
      userBubbleText:        '#FFFFFF',
      assistantBubbleBg:     '#FFFFFF',
      assistantBubbleBorder: '#E1E4E8',
      bubbleText:            '#1A1A1A',
      // was #9AA0A6 — 2.64:1 on white. Now 6.05:1, matching reactionAction.
      sentStatus:            '#5F6368',
      // replaces a hardcoded #f57c00 that measured 2.70:1 here. Now 5.02:1 on
      // the assistant bubble and 4.60:1 on the system bubble.
      mentionText:           '#B45309',
      reactionAction:        '#5F6368',
      reactionActionHover:   '#1A1A1A',
      systemBubbleBg:        '#F4F5F7',
    },
  },
  typography: {
    fontFamily: "'Proxima Nova', sans-serif",
  },
});

export default defaultTheme;
